const Const = {
    SERVER_SUCCESS_NOTIFIER_IS_ACTIVE: 'SERVER_SUCCESS_NOTIFIER_IS_ACTIVE',
    SERVER_SUCCESS_NOTIFIER_SET_SUCCESS_TEXT: 'SERVER_SUCCESS_NOTIFIER_SET_SUCCESS_TEXT',
    SERVER_SUCCESS_NOTIFIER_CLEAR: 'SERVER_SUCCESS_NOTIFIER_CLEAR',
};

export default Const;